module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect"
  }, [_c('input', {
    staticClass: "mdl-checkbox__input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "id": _vm.id
    },
    domProps: {
      "checked": _vm.checked,
      "value": _vm.value
    }
  }), _vm._v(" "), (_vm.label) ? _c('span', {
    staticClass: "mdl-checkbox__label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-306a33bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiCheckbox.vue
// module id = 266
// module chunks = 2